import { useEffect, useRef } from "react";

// Calls onTimeout after `minutes` of no user activity. Enabled only when active=true.
export default function useInactivityLogout(active, onTimeout, minutes = 5) {
  const timer = useRef(null);
  const cb = useRef(onTimeout);
  cb.current = onTimeout;

  useEffect(() => {
    if (!active) return;
    const ms = minutes * 60 * 1000;
    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => cb.current && cb.current(), ms);
    };
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [active, minutes]);
}
